module.exports = "/_next/static/images/90b6ff5c2b38092b31dcdeb7d3104758-perks-lg-2x.jpg.webp";